import { RUNNING_TRAINING_CHOICES, isRunningTrainingSelection } from "./runningTrainingSelection";

// Presentation groups only. They never rewrite the scoring/activity category.
export const TRAINING_GROUPS = Object.freeze([
  { id: "training-team", unitType: "team_training", labelKey: "trainingUnitType_team_training", title: "Mannschaftstraining", title_en: "Team training", icon_id: "football" },
  { id: "training-strength", unitType: "strength_training", labelKey: "trainingUnitType_strength_training", title: "Krafttraining", title_en: "Strength training", icon_id: "strength" },
  { id: "training-individual", unitType: "individual_training", labelKey: "trainingUnitType_individual_training", title: "Individualtraining", title_en: "Individual training", icon_id: "training" },
  { id: "training-running", unitType: "running_training", labelKey: "trainingUnitType_running_training", title: "Lauftraining", title_en: "Running training", icon_id: "running" },
]);
export const UNASSIGNED_TRAINING_GROUP = "training-unassigned";
export function trainingGroupId(item) {
  if (item?.group_id) return item.group_id;
  if (isRunningTrainingSelection(item)) return "training-running";
  const unit = item?.training_unit_type || item?.trainingUnitType || item?.unitType || item?.unit_type;
  return TRAINING_GROUPS.find(group => group.unitType === unit)?.id || UNASSIGNED_TRAINING_GROUP;
}
export function trainingGroups(groups = [], items = [], lang = "de") {
  const result = TRAINING_GROUPS.map(group => ({ ...group }));
  for (const group of groups) if (!result.some(row => row.id === group.id)
    && (group.status !== "archived" || items.some(item => item.group_id === group.id))) result.push(group);
  for (const item of items) {
    const id = trainingGroupId(item);
    if (!result.some(group => group.id === id)) result.push({ id,
      title: id === UNASSIGNED_TRAINING_GROUP ? "Nicht zugeordnet" : "Gespeicherte Gruppe",
      title_en: id === UNASSIGNED_TRAINING_GROUP ? "Unassigned" : "Saved group", icon_id: "training" });
  }
  return result.map(group => ({ ...group, label: (lang === "en" && group.title_en) || group.title }));
}
export function runningSystemId(choice) {
  if (!RUNNING_TRAINING_CHOICES.includes(choice)) return null;
  return choice === "tennis_interval" ? "system-tennis-interval"
    : choice === "sidestep" ? "system-sidestep" : `system-running-${choice}`;
}
export function effectiveTrainingTemplates(items = []) {
  const byIdentity = new Map();
  for (const item of items) {
    // The old generic running record is a container, not an eighth variant.
    if ((item.system_template_id || item.id) === "system-running-training"
      && !item.running_variant && !item.training_template && !item.training_structure) continue;
    const key = item.system_template_id || item.id;
    const previous = byIdentity.get(key);
    if (!previous || (item.version || 0) > (previous.version || 0)) byIdentity.set(key, item);
  }
  return [...byIdentity.values()];
}
